	<template>
	<div class="bg-white">
		<!--
			Универсальный 3-колоночный shell модуля community.
			Геометрия: левая/правая рельсы РАВНОЙ ширины, контент по центру, hero —
			над центром. На мобайле колонки схлопываются «контент-первым»
			(hero → центр → левая → правая). На странице поста/редактора рельсы и hero
			скрыты, центр сужается до читабельной ширины.

			Наполнение колонок — слоты #hero / #aside-left / #aside-right. Дефолтное
			содержимое слотов (ниже) сохраняет прежнее поведение модуля (категории +
			последние комментарии + популярные сообщества), чтобы community работал
			«из коробки» без оверрайда. Проект ПЕРЕОПРЕДЕЛЯЕТ слоты своим контентом,
			подсунув собственный layout-компонент через
			global.config.modules.community.settings.layout (он оборачивает этот shell
			и кладёт в слоты что угодно) — см. community.client.js.
		-->
		<!-- На мобайле обнуляем ТОЛЬКО боковой/нижний паддинг (карточки edge-to-edge),
		     но СОХРАНЯЕМ верхний (pd-t-extra) — иначе hero уезжает под фикс-хедер (64px). -->
		<section
			class="community-grid w-100 pd-l-medium pd-r-medium pd-t-extra pd-b-medium mobile:pd-l-zero mobile:pd-r-zero mobile:pd-b-zero pos-relative"
			:class="{ 'community-grid--focus': !isFeedView }"
		>

			<!-- HERO (слот) — над центром, только в режиме ленты -->
			<div
				v-if="isFeedView && $slots.hero"
				class="community-grid__hero w-100"
			>
				<slot name="hero" />
			</div>

			<!-- ЛЕВАЯ РЕЛЬСА (слот) -->
			<aside
				v-if="isFeedView"
				class="community-grid__aside-left community-rail w-100"
			>
				<slot name="aside-left">
					<!-- DEFAULT: навигация по категориям (подборка/популярное/свежее/подписки) -->
					<ul class="w-100 bg-light radius-medium mobile:radius-zero pd-medium mobile:pd-small p-regular gap-thin flex-column flex">
						<li
							:class="{'t-black bg-white': route.params.category === 'featured' }"
							@click="() => { blog.state.sort.param = 'createdAt'; router.push({name: 'Blog', params: { category: 'featured' } })}"
							class="cursor-pointer flex-v-center flex fw-medium  pd-thin radius-small"
						>
							<IconFeatured class="i-medium mn-r-thin opacity-50"/>
							{{ $t('community.blog.categories.featured') }}
						</li>
						<li
							:class="{'t-black bg-white': route.params.category === 'popular' }"
							@click="() => { blog.state.sort.param = 'views'; router.push({name: 'Blog', params: { category: 'popular' } }) }"
							class="cursor-pointer fw-medium flex-v-center flex  pd-thin radius-small"
						>
							<IconPopular class="i-medium mn-r-thin opacity-50"/>
							{{ $t('community.blog.categories.popular') }}
						</li>
						<li
							:class="{'t-black bg-white': route.params.category === 'new'}"
							@click="() => { blog.state.sort.param = 'createdAt'; router.push({name: 'Blog', params: { category: 'new' } })}"
							class="cursor-pointer fw-medium flex-v-center flex  pd-thin radius-small"
						>
							<IconRecent class="i-medium mn-r-thin opacity-50"/>
							{{ $t('community.blog.categories.recent') }}
						</li>
						<li
							v-if="auth.state.user._id"
							:class="{'t-black bg-white': route.params.category === 'following'}"
							@click="() => { blog.state.sort.param = 'createdAt'; router.push({name: 'Blog', params: { category: 'following' } })}"
							class="cursor-pointer fw-medium flex-v-center flex pd-thin radius-small"
						>
							<IconFollowing class="i-medium mn-r-thin opacity-50"/>
							{{ $t('community.blog.categories.following') }}
						</li>

						<router-link
							v-if="canCreatePost"
							:to="{
								name: 'CreateBlogPost'
							}"
							class="button fw-medium button--main w-100 mn-t-thin"
						>
							{{ $t('community.blog.createPost') }}
						</router-link>
					</ul>
				</slot>
			</aside>

			<!-- ЦЕНТР: период-шапка (контрол ленты) + содержимое (Feed / пост).
			     Без серой подложки/панели — лента и статья на белом. Серый остаётся
			     осмысленно: карточки .card в ленте и блок комментариев на странице поста. -->
			<div
				class="community-grid__center w-100 pos-relative"
				:class="{ 'community-post-column': isPostView }"
			>
				<header
					v-if="isFeedView"
					class="card mobile:radius-zero mn-b-medium t-black"
				>
					<!-- Период — часть самого заголовка H4: подчёркнут пунктиром, выделен
					     цветом --main. По наведению/клику выезжает аккуратное меню. Меню
					     закрывается с задержкой, чтобы зазор «слово → меню» не схлопывал его. -->
					<h4 class="ws-nowrap mn-0">
						{{ $t('community.blog.header') }}
						<span
							class="period-dropdown pos-relative d-inline-block"
							@mouseenter="openPeriod"
							@mouseleave="closePeriod"
						>
							<button
								type="button"
								@click="periodOpen = !periodOpen"
								:aria-expanded="periodOpen"
								class="period-dropdown__trigger cursor-pointer"
							>
								<span class="period-dropdown__label">{{ currentPeriodLabel }}</span>
								<span class="period-dropdown__caret" :class="{ 'period-dropdown__caret--open': periodOpen }">⌄</span>
							</button>

							<transition name="TransitionTranslateY">
								<ul
									v-show="periodOpen"
									class="period-dropdown__menu pos-absolute pos-t-100 pos-l-0 z-index-5 bg-white radius-small pd-thin"
								>
									<li
										v-for="option in periodOptions"
										:key="option.value"
										@click="selectPeriod(option.value)"
										class="period-dropdown__item radius-thin pd-t-thin pd-b-thin pd-l-small pd-r-small cursor-pointer ws-nowrap"
										:class="{ 'period-dropdown__item--active': blog.state.filter.period === option.value }"
									>
										{{ option.name }}
									</li>
								</ul>
							</transition>
						</span>
					</h4>
				</header>

				<router-view v-slot="{ Component, route }">
					<transition name="scaleIn" mode="out-in">
						<component ref="page" :key="route.query" :is="Component" />
					</transition>
				</router-view>
			</div>

			<!-- ПРАВАЯ РЕЛЬСА (слот) -->
			<aside
				v-if="isFeedView"
				class="community-grid__aside-right community-rail w-100"
			>
				<slot name="aside-right">
					<!-- DEFAULT: последние комментарии (скрыто, пока пусто) -->
					<div v-if="comments.length" class="radius-medium bg-light mn-b-thin pd-small">
						<div class="gap-thin flex-nowrap flex">
							<p class="fw-medium mn-b-small">{{ $t('community.blog.latestComments') }}</p>
						</div>

						<div class="flex flex-column gap-thin">
							<Comment
				        	v-for="comment in comments.slice(0,5)"
					        :key="comment._id"
					        :comment="comment"
					        :target="target"
					        :type="type"
					        :owner="owner"
					        @reply="handleReply"
					        @load-more="loadMoreChildren"
					        class="comment bg-white pd-small radius-regular"
					      />
					    </div>
				    </div>

			      <div v-if="hasOrganizations" class="radius-medium bg-light pd-small">
						<div class="gap-thin flex-v-center flex-nowrap flex  mn-b-small">
							<p class="text-box-trim-end fw-medium">{{ $t('community.blog.popularCommunities') }}</p>

							<router-link
								v-if="auth.state.user._id"
								to="/organizations/create"
								class="fw-medium cursor-pointer hover:scale-[1.05] radius-extra flex-center flex i-medium bg-main"
							>
								+
							</router-link>
						</div>

						<transition name="slide-fade">
							<Feed
								:showLoadMore="false"
								:LoadMore="false"
						      :states="{
						        empty: {
						          title: $t('community.blog.noOrgsFound'),
						          description: $t('community.blog.noOrgsFoundDesc')
						        }
						      }"
						      :store="{
						        read: (options) => store.organizations.actions.read(options),
						        state: store.organizations.state
						      }"
						      :options="{
						        	user: auth.state.user._id,
											sort: 'numberOfMemberships',
											contain: ['blogposts'],
											lookup: ['blogposts'],
											limit: 10
						      }"
						      v-slot="{
						        items
						      }"
						      class="flex flex-column gap-thin"
						    >
						    	<CardOrganization
					    			v-for="organization in items"
					        	:key="organization._id"
						      	:organization="organization"
						      	:user="auth.state.user"
						      	:showProducts="false"
						      	:showRating="false"
						      	:showFeatured="false"
						      	:showFollowers="false"
										@updateMembership="handleMembershipUpdate"
										class="pd-small w-100 bg-white radius-regular o-hidden"
							    />
						    </Feed>
						</transition>
					</div>
				</slot>
			</aside>

		</section>
	</div>
</template>

<script setup="props">
	import { computed, defineAsyncComponent, onMounted, toRefs, ref, useSlots } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

	import Feed from '@martyrs/src/design-system/components/Feed/Feed.vue'

	import IconFeatured from '@martyrs/src/modules/icons/entities/IconFeatured.vue'
	import IconPopular from '@martyrs/src/modules/icons/entities/IconPopular.vue'
	import IconRecent from '@martyrs/src/modules/icons/entities/IconRecent.vue'
	import IconFollowing from '@martyrs/src/modules/icons/entities/IconFollowing.vue'


import axios from 'axios';


import Comment from '../sections/Comment.vue';


const $axios = axios.create({ baseURL: process.env.API_URL });
const comments = ref([]);
const commentContent = ref('');

const fetchComments = async () => {
  try {
    const response = await $axios.get('/comments/read', {
      params: {
        maxDepth: 1,
        format: 'plain'
      }
    });
    comments.value = response.data;
  } catch (error) {
    console.error('Error fetching comments:', error);
  }
};

// Дефолтную загрузку комментариев делаем ТОЛЬКО если проект не переопределил
// правую рельсу своим слотом — иначе это лишний запрос (дефолтный блок не виден).
const slots = useSlots();
if (!slots['aside-right']) fetchComments();

// Import state
import * as blog from '@martyrs/src/modules/community/store/blogposts.js';
import * as auth from '@martyrs/src/modules/auth/views/store/auth.js'
import { useStore } from '@martyrs/src/modules/core/views/store/core.store.js'

// Глобальный стор: organizations и его CardOrganization подгружаем ТОЛЬКО если
// модуль организаций реально зарегистрирован (`store.organizations`). Без него
// блок «Popular Communities» не рендерится — community остаётся standalone.
const store = useStore()
const hasOrganizations = computed(() => Boolean(store.organizations))
const postingPolicy = computed(() => store.community?.state?.posting || 'auth')
const isAdmin = computed(() => (auth.state.access?.roles || []).includes('ROLE_ADMIN'))
const canCreatePost = computed(() => {
	if (postingPolicy.value === 'public') return true
	if (postingPolicy.value === 'admin') return isAdmin.value
	return Boolean(auth.state.user?._id)
})

const CardOrganization = defineAsyncComponent(() =>
	import('@martyrs/src/modules/organizations/components/blocks/CardOrganization.vue')
)

// State
const route = useRoute();
const router = useRouter();

// Режимы shell:
//  - isPostView: открыт пост или его редактор (`posts/:url`, `posts/:url/edit`) →
//    рельсы/hero скрыты, центр сужается (.community-post-column).
//  - isCreateView: страница создания поста → тоже без рельс/hero.
//  - isFeedView: всё остальное (лента) → 3 колонки + hero + период-шапка.
const isPostView = computed(() => Boolean(route.params.url));
const isCreateView = computed(() => String(route.name || '').includes('CreateBlogPost'));
const isFeedView = computed(() => !isPostView.value && !isCreateView.value);

if (route.params.category === 'popular') blog.state.sort.param = 'views';
if (route.params.category === 'new') blog.state.sort.param = 'createdAt';

import { useI18n } from 'vue-i18n'
const { t } = useI18n()

// Опции периода — массив объектов, чтобы Select отрисовал переведённые
// лейблы; value хранится в `blog.state.filter.period` как короткий ключ.
// Select.vue показывает `option.name`, биндимся к строковому `value` через
// property="value" — `blog.state.filter.period` остаётся коротким ключом.
const periodOptions = computed(() => [
	{ value: 'today', name: t('community.blog.periods.today') },
	{ value: 'week',  name: t('community.blog.periods.week') },
	{ value: 'month', name: t('community.blog.periods.month') },
	{ value: 'year',  name: t('community.blog.periods.year') },
	{ value: 'all',   name: t('community.blog.periods.all') },
])

// Период-дропдаун (заменил martyrs Select — он внутри h4 наследовал крупный
// жирный шрифт и центрирование, меню выглядело гротескно). Открытие по наведению
// и по клику; закрытие отложенное, чтобы зазор пилюля→меню не схлопывал его.
const periodOpen = ref(false)
let periodCloseTimer = null
const openPeriod = () => { clearTimeout(periodCloseTimer); periodOpen.value = true }
const closePeriod = () => { periodCloseTimer = setTimeout(() => { periodOpen.value = false }, 120) }
const selectPeriod = (value) => { blog.state.filter.period = value; periodOpen.value = false }
const currentPeriodLabel = computed(() => {
	const found = periodOptions.value.find(o => o.value === blog.state.filter.period)
	return found ? found.name : t('community.blog.periods.all')
})


const handleMembershipUpdate = async ({ membership, status, target }, statusName, statusNumber) => {
	if (!hasOrganizations.value) return
	// memberships-store у organizations публикуется через addStore — лезем туда,
	// а не в статический импорт, чтобы community не ломался без organizations.
	const memberships = store.memberships
	const currentOrg = store.organizations.state.current
	if (memberships?.handleMembershipUpdate) {
		memberships.handleMembershipUpdate(currentOrg, membership, status, target, statusName, statusNumber)
	}
};

</script>

<style lang="scss">
// 3-колоночный shell: рельсы равной ширины (--community-rail), центр тянется.
// align-items:start — чтобы sticky-рельсы работали.
.community-grid {
  display: grid;
  align-items: start;
  column-gap: var(--medium);
  row-gap: var(--medium);
  --community-rail: 20rem;
  grid-template-columns: var(--community-rail) minmax(0, 1fr) var(--community-rail);
  grid-template-areas:
    "hero   hero    hero"
    "aleft  center  aright";
}

.community-grid__hero        { grid-area: hero; }
.community-grid__aside-left  { grid-area: aleft; }
.community-grid__center      { grid-area: center; }
.community-grid__aside-right { grid-area: aright; }

// Рельсы прилипают при скролле (скроллится #scrollview / window — sticky тянется
// относительно ближайшего скролл-контейнера).
.community-rail {
  position: sticky;
  top: 1rem;
}

// Фокус-режим (пост/создание): одна центрированная колонка, без рельс.
.community-grid--focus {
  grid-template-columns: minmax(0, 1fr);
  grid-template-areas: "center";
}

// Страница поста: центр сужается до читабельной ширины.
.community-post-column {
  max-width: 52rem;
  margin-left: auto;
  margin-right: auto;
}

// Период-дропдаун в шапке ленты — период как часть заголовка H4 (инлайн).
// Триггер наследует размер/жирность H4, выделен цветом --main, пунктир под словом.
.period-dropdown__trigger {
  border: 0;
  background: transparent;
  padding: 0;
  font: inherit;
  color: rgb(var(--main));
  cursor: pointer;
  vertical-align: baseline;
}
.period-dropdown__label {
  border-bottom: 1px dashed rgba(var(--main), 0.45);
  transition: border-color 0.15s ease;
}
.period-dropdown__trigger:hover .period-dropdown__label {
  border-bottom-color: rgb(var(--main));
}

.period-dropdown__caret {
  display: inline-block;
  position: relative;
  top: -2px;
  margin-left: 0.15em;
  font-size: 0.75em;
  line-height: 1;
  transition: transform 0.2s ease;
}
.period-dropdown__caret--open { transform: rotate(180deg); }

// Меню — нейтральная карточка, шрифт сбрасываем с крупного H4 на обычный.
.period-dropdown__menu {
  min-width: 9rem;
  margin-top: var(--thin);
  list-style: none;
  border: 1px solid rgba(var(--black), 0.06);
  box-shadow: 0 0.75rem 1.5rem rgba(var(--black), 0.12);
}
.period-dropdown__item {
  font-size: 1rem;
  font-weight: 400;
  color: rgb(var(--dark));
  transition: background 0.15s ease, color 0.15s ease;
}
.period-dropdown__item:hover {
  background: rgba(var(--main), 0.08);
  color: rgb(var(--black));
}
.period-dropdown__item--active {
  background: rgba(var(--main), 0.1);
  color: rgb(var(--main));
  font-weight: 500;
}

// Мобайл: схлопываем в одну колонку, «контент-первым» (центр выше рельс).
// Рельсы становятся статичными (не sticky), уходят под ленту.
@media screen and (max-width: 1025px) {
  .community-grid {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas:
      "hero"
      "center"
      "aleft"
      "aright";
  }
  .community-rail {
    position: static;
    top: auto;
  }
}
</style>
